<template>
  <router-view :companies="companies" />
</template>
<script>
export default {
  name: 'fixed-layout',
  data(){
    return {
      companies: []
    }
  }
}
</script>




// WEBPACK FOOTER //
// FixedLayout.vue?4009bddc